export default "__VITE_ASSET__Dld8Qs$u__"